import { Injectable } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';

export interface TourStep {
  elementId: string;
  title: string;
  description: string;
  openMenu?: boolean;          // optional
  onStepAction?: () => void; 
}

@Injectable({
  providedIn: 'root'
})
export class TourService {

  // List of all tour steps
  steps: TourStep[] = [];

  // Index of the current step
  currentStepIndex = 0;

  // Emits whenever the step changes
  currentStep$ = new BehaviorSubject<TourStep | null>(null);

  // Emits when we want to trigger opening the side menu
  menuToggleRequest = new Subject<void>();

  constructor() { }

  startTour(steps: TourStep[]) {
    this.steps = steps;
    this.currentStepIndex = 0;
    this.emitCurrentStep();
  }

private emitCurrentStep() {
  const step = this.steps[this.currentStepIndex] || null;

  // 1️⃣ If this step wants the menu open, emit event to TopNavbar
  if (step?.openMenu) {
    this.menuToggleRequest.next();
  }

  // 2️⃣ Run any custom per-step action
  try {
    step?.onStepAction?.();
  } catch (e) {
    console.error('Tour step action failed:', e);
  }

  // 3️⃣ Finally, emit the step data for the overlay
  this.currentStep$.next(step);
}


  nextStep() {
    if (this.currentStepIndex < this.steps.length - 1) {
      this.currentStepIndex++;
      this.emitCurrentStep();
    }
  }

  prevStep() {
    if (this.currentStepIndex > 0) {
      this.currentStepIndex--;
      this.emitCurrentStep();
    }
  }

  goToStep(index: number) {
    if (index >= 0 && index < this.steps.length) {
      this.currentStepIndex = index;
      this.emitCurrentStep();
    }
  }

  endTour() {
    this.steps = [];
    this.currentStepIndex = 0;
    this.currentStep$.next(null);
  }
}
